import "~antd/dist/antd.min.css";
import "./App.css";
import { BrowserRouter, Route, Routes, useSearchParams } from "react-router-dom";
import { BACKEND_PARAMS, BUILD_DATE, IS_IOS_DEVICE, SHOW_BUILD_DATE } from "config";
import { usePromise } from "utils/usePromise";
import { cssGrayscale, promisedComponent, useMobileQuery } from "utils/utils";
import { ok } from "utils/types";
import { ConfigProvider } from "antd";
import { Loader } from "components/Loader";
import { antLocales, initLocalization } from "initLocalization";
import { useLanguage } from "utils/useLanguage";

function Root() {
  const [searchParams] = useSearchParams();
  const path = searchParams.get("path") ?? BACKEND_PARAMS.path;
  const lang = useLanguage();

  const promised = usePromise(async () => {
    await initLocalization(lang);
    if (path === "editor") {
      const { WidgetEditor } = await import("components/ProductScenarioEditor");
      return ok(<WidgetEditor />);
    }
    if (path === "home") {
      const { Home } = await import("components/Home");
      return ok(<Home />);
    }
    const { CartPage, ProductPage } = await import("components/Product");
    if (path === "cart") {
      return ok(<CartPage />);
    }
    return ok(<ProductPage />);
  });

  if (window.opener && path === "auth") {
    window.opener.postMessage({
      type: "auth",
      searchParams: searchParams.toString(),
    });
    window?.close();
    return <></>;
  }
  if (window.opener && path === "payment") {
    window.opener.postMessage({
      type: "payment",
      searchParams: searchParams.toString(),
    });
    window?.close();
    return <></>;
  }

  return (
    <ConfigProvider locale={antLocales[lang]}>
      {promisedComponent(promised, {
        loading: Loader({ mode: "default" }),
        resolved: ({ res: component }) => component,
      })}
    </ConfigProvider>
  );
}

function App() {
  const mobile = useMobileQuery();

  return (
    <div className="App">
      <div
        style={{
          color: cssGrayscale(0, 0.15),
          position: "absolute",
          [mobile ? "top" : "bottom"]: 4,
          right: 4,
          zIndex: 99999,
          display: SHOW_BUILD_DATE ? "initial" : "none",
        }}
      >
        {`IOS: ${IS_IOS_DEVICE}; `}
        {`Build Date: ${BUILD_DATE}`}
      </div>
      <BrowserRouter>
        <Routes>
          {/* <Route path="product" element={<ProductPage />} />
          <Route path="product/:productId" element={<ProductPage />} />
          <Route path="home" element={"hey2"} />

          <Route path="editor">
            <Route path="product/:productId" element={<WidgetEditor />} />
            <Route path="home" element={"hey4"} />
            <Route path="*" element={<WidgetEditor />} />
          </Route> */}
          <Route path="*" element={<Root />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
